import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/feed-post.css");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/packages/ui/src/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/ui/link-button.tsx");
